import {
  useMyCustomersAutocomplete,
  useMyCustomersProbe,
} from '~/common/hooks';
import {
  SharedCustomerSelector,
  useCustomerChangeHandler,
} from '~/purchase/components';

function PrimaryCustomerSelector() {
  const customersProbe = useMyCustomersProbe();
  const fetchCustomers = useMyCustomersAutocomplete();
  const onChange = useCustomerChangeHandler();

  return (
    <SharedCustomerSelector
      customersProbe={customersProbe}
      fetchCustomers={fetchCustomers}
      onChange={onChange}
      onFocus={() => {}}
    />
  );
}

export default PrimaryCustomerSelector;
